import { connect, Dispatch } from 'react-redux';
import AbstractDriveItemListPage, { AbstractDriveItemListPageProps } from '../abstract';
import { StoreState } from '../../../reducers';
import { getOrFetchDriveItemMeta } from '../../DriveItemList/actions';
import UserAgentUtils from '../../../utils/userAgent';
import { FetchStatus, getDriveItemStatusFromMap } from '../../DriveItemList/reducer';

interface FolderDriveItemListPageProps extends AbstractDriveItemListPageProps {
	dispatch: Dispatch<StoreState>;
}

export class FolderDriveItemListPage extends AbstractDriveItemListPage<FolderDriveItemListPageProps> {

	headerLabel = 'messages.folder';
	noItemsLabel = 'messages.no_assets';
	hasBreadCrumbs = true;

	initializeView(props: FolderDriveItemListPageProps): void {
		const driveFolderId = this.getDriveFolderId(props);
		if (driveFolderId && !UserAgentUtils.isMobileApp) {
			const { dispatch } = props;
			dispatch(getOrFetchDriveItemMeta(driveFolderId));
		}
	}

	getDriveItemIds(): number[] {
		const driveItemsStore = this.props.driveList.driveItems;
		const driveFolderId = this.getDriveFolderId();
		if (driveFolderId) {
			const driveFolder = driveItemsStore[driveFolderId];

			if (driveFolder) {
				const { resources } = driveFolder;
				return resources ? resources.map(resource => resource.id) : [];
			}
		}
		return [];
	}

	isFetching(driveItemIds: number[]): boolean {
		const driveFolderId = this.getDriveFolderId();

		if (driveFolderId && !UserAgentUtils.isMobileApp) {
			const { driveItemsFetchStatus } = this.props.driveList;
			const driveFolderFetchStatus = getDriveItemStatusFromMap(driveItemsFetchStatus, driveFolderId);
			const { contentBlocksStatus, metaFetchStatus } = driveFolderFetchStatus;

			if (metaFetchStatus !== FetchStatus.FETCHED && metaFetchStatus !== FetchStatus.ERROR) {
				return true;
			}

			const blocks = Object.keys(contentBlocksStatus);
			for (let i = 0; i < blocks.length; i++) {
				const block = blocks[i];
				const blockStatus: FetchStatus = contentBlocksStatus[block];

				if (blockStatus === FetchStatus.FETCHING) {
					return true;
				}
			}
		}
		return false;
	}
}

export default connect()(FolderDriveItemListPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemListPage/extends/Folder.tsx